export default __webpack_public_path__ + "static/media/trash-icon.27b417d7.svg";